<template>
  <div class="cursor" :style="style">
    <img :src="cursor" alt="">
    <span class="name">{{name}}</span>
  </div>
</template>

<script>

import cursor from '../assets/cursor.png'

export default {
  props: {
    name: {
      type: String,
      required: true
    },
    x: {
      type: Number,
      required: true
    },
    y: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      cursor,
      color: '#000000'
    }
  },
  computed: {
    style: function() {
      return `
        left: ${this.x}px;
        top: ${this.y}px;
      `;
    }
  }
}
</script>

<style scoped>

.cursor {
  position: absolute;
  transition: 100ms;
  z-index: 3;

  display: flex;
}

img {
  width: 20px
}

span.name {
  font-size: 10px;
  transform: translate(0, 10px);
}

</style>



// WEBPACK FOOTER //
// src/components/Cursor.vue